/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    LECTURE: 'lecture',
    COURSE: 'course',
    WORKSHOP: 'workshop',
    BUNDLE: 'bundle',
};
